import React from "react";
import classes from "./contestSection.module.css";
import { useNavigate } from "react-router-dom";

const ContestSection = ({ contests, loading }) => {
  const navigate = useNavigate();

  const handleStartCompeting = () => {
    navigate("/artist-next-door-arena/compete");
  };

  const handleVoteNow = () => {
    navigate("/artist-next-door-arena/vote-now");
  };
  // Calculate days left for contest
  const getDaysLeft = (endDate) => {
    const end = new Date(endDate);
    const today = new Date();
    const diffTime = Math.abs(end - today);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <section className={classes.contestSection} id="contests">
      <div className={classes.sectionHeader}>
        <h2 className={classes.sectionTitle}>
          Ongoing <span className={classes.highlight}>Contests</span>
        </h2>
        <p className={classes.sectionDescription}>
          Participate in our live contests and showcase your talent to the world
        </p>
      </div>

      <div className={classes.contestContent}>
        <div className={classes.contestFilter}>
          <button className={`${classes.filterButton} ${classes.active}`}>
            All Categories
          </button>
          <button className={classes.filterButton}>Singing</button>
          <button className={classes.filterButton}>Dancing</button>
          <button className={classes.filterButton}>Photography</button>
          <button className={classes.filterButton}>Video Editing</button>
          <button className={classes.filterButton}>Magic</button>
        </div>

        {loading ? (
          <div className={classes.loadingContainer}>
            <div className={classes.loader}></div>
            <p>Loading contests...</p>
          </div>
        ) : (
          <div className={classes.contestsGrid}>
            {contests.map((contest) => (
              <div key={contest.id} className={classes.contestCard}>
                <div className={classes.contestBadge}>{contest.category}</div>
                <div className={classes.contestDetails}>
                  <h3 className={classes.contestTitle}>{contest.title}</h3>
                  <p className={classes.contestDescription}>
                    {contest.description}
                  </p>

                  <div className={classes.contestMeta}>
                    <div className={classes.metaItem}>
                      <span className={classes.metaIcon}>🕒</span>
                      <span className={classes.metaText}>14 Days Duration</span>
                    </div>
                    <div className={classes.metaItem}>
                      <span className={classes.metaIcon}>👥</span>
                      <span className={classes.metaText}>
                        {contest.participants} participants
                      </span>
                    </div>
                  </div>

                  <div className={classes.contestActions}>
                    <button
                      className={classes.participateButton}
                      onClick={handleStartCompeting}
                    >
                      Participate
                    </button>
                    <button
                      className={classes.voteButton}
                      onClick={handleVoteNow}
                    >
                      Vote
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className={classes.viewMoreContainer}>
          <button
            className={classes.viewMoreButton}
            onClick={handleStartCompeting}
          >
            View All Contests
            <span className={classes.arrowIcon}>→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContestSection;
